import type { SuperBillingListRequest } from '@tandemone/types'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { getSuperBillingList } from './api'

export const SUPER_BILLING_LIST_KEY = ['super', 'billing', 'list'] as const

export const SUPER_BILLING_DEFAULT_PAGE_SIZE = 10

/* keepPreviousData holds the rendered page while the next one fetches, so the
 * table does not flash empty between pages or as search debounces. */
export function useSuperBillingList(
  opts: SuperBillingListRequest & { page: number }
) {
  const pageSize = opts.pageSize ?? SUPER_BILLING_DEFAULT_PAGE_SIZE
  const search = opts.search?.trim() || undefined
  const { sort, order } = opts
  return useQuery({
    queryKey: [
      ...SUPER_BILLING_LIST_KEY,
      { page: opts.page, pageSize, search, sort, order }
    ],
    queryFn: ({ signal }) =>
      getSuperBillingList(
        { page: opts.page, pageSize, search, sort, order },
        signal
      ),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
    retry: false
  })
}
